<div
  class="main-menu"
  *ngIf="
    (menuItems$ | async).length > 0 && {
      expanded: isExpanded$ | async,
      menuItems: menuItems$ | async,
      menuItemsSecondary: menuItemsSecondary$ | async,
    } as data
  "
  [class.expanded]="data.expanded"
  [class.double]="data.menuItemsSecondary.length > 0"
>
  <div
    class="toggle"
    (click)="toggleSidebar()"
    *ngIf="mainMenuCanToggle$ | async"
  >
    <a
      ><fa-icon
        [icon]="!isRtl ? ['fas', 'arrow-right'] : ['fas', 'arrow-left']"
      ></fa-icon
    ></a>
  </div>

  <div class="app-menu">
    <!-- Company Section -->
    <div class="module" [class.border-bottom]="!data.expanded" *ngIf="hasUser">
      <app-module-switch [showActiveInfo]="data.expanded"></app-module-switch>
    </div>

    <!-- Search Section -->
    <app-search-input
      (inputChanged)="onSearchChange($event)"
      *ngIf="data.expanded"
    ></app-search-input>

    <!-- Back Button -->
    <div class="back" *ngIf="hasBackButton">
      <a (click)="back()">
        <span class="back-btn">
          <fa-icon [icon]="['fas', 'arrow-left']" size="1x"></fa-icon>
        </span>
        {{ "main-menu.button.back" | translate }}
      </a>
    </div>

    <!-- Menu Section -->
    <div class="menus">
      <!-- Primary and Secondary Menu -->
      <ng-container
        *ngFor="
          let menuItems of [data.menuItems, data.menuItemsSecondary];
          let i = index
        "
      >
        <ul
          class="menu-items"
          [class.filtered]="filtered"
          *ngIf="menuItems.length > 0"
          [class.second]="i > 0"
          [class.menu-items-small]="!data.expanded"
        >
          <li
            *ngFor="let menu of menuItems"
            [class.menu-item]="data.expanded"
            [class.menu-item-small]="!data.expanded"
            placement="right"
          >
            <ng-container>
              <ul class="submenu-items">
                <div class="header-item" (click)="toggleMenuHeader(menu)">
                  <span>{{ menu.title }}</span>
                  <fa-icon
                    class="submenu-icon"
                    [icon]="
                      menu.expanded
                        ? ['fas', 'caret-up']
                        : ['fas', 'caret-down']
                    "
                  ></fa-icon>
                </div>
                <ng-container>
                  <li
                    *ngFor="let submenu of menu.children"
                    [class.should-hide]="!menu.expanded"
                    [class.search-match]="
                      searchString &&
                      submenu.title
                        ?.toLowerCase()
                        .includes(searchString.toLowerCase())
                    "
                    [class.d-none]="
                      searchString &&
                      !submenu?.title
                        .toLowerCase()
                        .includes(searchString.toLowerCase())
                    "
                    [routerLink]="submenu.link"
                    [routerLinkActive]="['active']"
                    [suiTooltip]="!data.expanded ? submenu.title : null"
                  >
                    <div class="submenu-item">
                      <fa-icon
                        class="submenu-icon"
                        [icon]="submenu.icon"
                        size="lg"
                        [routerLink]="submenu.link"
                      ></fa-icon>
                      <a
                        class="title"
                        [innerHTML]="submenu.title | highlight: searchString"
                      >
                      </a>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </ng-container>
          </li>
        </ul>
      </ng-container>
    </div>
  </div>
</div>
